//修订批准
import React from 'react'
import Manager from 'Tyan/public/components/Manager'
import DocumentRevisionDiv from './DocumentRevisionDiv'

Ext.require('Ext.Toast')

const config = {
    
            buttons: [
            ],
            columns: [
                { _text: '文件编号', field: 'QualityFileNumber', minWidth: 250, search: true, },
                { _text: '文件名称', field: 'QualityFileName', minWidth: 350, search: true, },
                { _text: '版别', field: 'Version', minWidth: 150,  },
                { _text: '所属目录', field: 'QualityFileDirectory', minWidth: 150,},
                { _text: '申请人', field: 'Creator', minWidth: 150,  },
                { _date: '申请日期', field: 'CreateTime', minWidth: 150,  },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data, record) => {
                Tyan.pubForm.showDialog('修订批准', props => <DocumentRevisionDiv {...props} id={data.id} onFlowFinished={refreshPage}  onSave={refreshPage} />)
            },
        }

export default props => <Manager {...props} config={config} />